import { render, staticRenderFns } from "./AppSheet.vue?vue&type=template&id=056ac8fe&scoped=true&"
import script from "./AppSheet.vue?vue&type=script&lang=ts&"
export * from "./AppSheet.vue?vue&type=script&lang=ts&"
import style0 from "./AppSheet.vue?vue&type=style&index=0&id=056ac8fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056ac8fe",
  null
  
)

export default component.exports